import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AlertMessageModel, AlertMessageModelNav } from '../models/common.model';
@Injectable({
  providedIn: 'root'
})
export class AlertMessageService {
  private isAlert = new BehaviorSubject<any>({});
  isAlert$ = this.isAlert.asObservable();
  private isAlert2 = new BehaviorSubject<any>({});
  isAlert2$ = this.isAlert2.asObservable();
  /**
   * show the loader icon
   */
  showAlert(alertMessage:AlertMessageModel):void {
    this.isAlert.next(alertMessage);
  }
  showAlertNav(alertMessage2:AlertMessageModelNav):void {
    this.isAlert2.next(alertMessage2);
  }
}
